let Api = {
    "N_SHOPHOME_FINDESPRODUCTPAGELIST": "/trade/n/ShopHome/findEsProductPageList", //商品列表
    "XLZB_SELNATIONCODE": "/standard/xlzb/selNationCode", //查询组织，国家，地区
    "XLZB_FINDXLZBTYPE": "/standard/xlzb/findXlzbType", //查询限量指标分类
    "XLZB_FINDLIST": "/standard/xlzb/findList",//数据列表 
    "XLZB_FINDPAGELIST": "/standard/xlzb/findPageList", //数据列表 - 分页查询限量指标列表
    "STANDARDMAGE_FINDPAGELIST": "/standard/n/app/StandardMage/findPageList", //标准查询分页查询列表
    "STANDARDMAGE_FINDINFO": "/standard/n/app/StandardMage/findInfo", //标准查询分页查询详情

    "XLZB_FINDLISTFOODCN": "/standard/xlzb/findListFoodCn", //数据列表 - 鲜朗查询产品名称列表


    
     "MDB_N_SELORGLISTSUM": "/mdb/n/selOrgListSum", //
     "MDB_N_SELORGLIST": "/mdb/n/selOrgList", //
    
     "SAMP_REPORTPAGE": "/dc/n/index/samp/reportPage", //
      
       "APPLYENTER_SAVE": "dc/n/applyEnter/save", //入驻申请
    
}
module.exports = Api